import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import PopModal from "../../../Constant/Custom/Models/PopModal";
import { serverUrl } from "../../../Constant/Static/config";
import { AuthContext } from "../../../Auth/AuthContext";
import {
  BC,
  MBC,
  BCM,
  SC,
  SCA,
  ST,
  STATES,
  DISTRICTS,
} from "../../../Constant/Static/config";
import Loader from "../../../Constant/Custom/Loader";

function PersonalDetails({ handleNext }) {
  const { auth } = useContext(AuthContext);

  const [loading, setLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalType, setModalType] = useState({ title: "", text: "", icon: "" });
  const [onConfirm, setOnConfirm] = useState(() => () => { });

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const storedUser = auth.user;
  // console.log(storedUser);

  const [communities, setCommunities] = useState([
    "OC",
    "BC",
    "BCM",
    "MBC",
    "SC",
    "SCA",
    "ST",
  ]);

  const [formData, setFormData] = useState({
    appNo: storedUser?.appno || "",
    appName: storedUser?.userName || "",
    email: storedUser?.email || "",
    phone: storedUser?.mobile || "",
    parentName: "",
    gender: "",
    dob: "",
    citizenship: "",
    aadhar: "",
    nativity: "",
    category: "",
    religion: "",
    community: "",
    caste: "",
    houseAddress: {
      address: "",
      street: "",
      village: "",
      taluk: "",
      district: "",
      pin: "",
    },
    permanentAddress: {
      address: "",
      street: "",
      village: "",
      taluk: "",
      district: "",
      pin: "",
    },
  });

  const setDefaultForm = () => {
    setFormData({
      appNo: storedUser?.appno || "",
      appName: storedUser?.userName || "",
      email: storedUser?.email || "",
      phone: storedUser?.mobile || "",
      parentName: "",
      gender: "",
      dob: "",
      aadhar: "",
      citizenship: "",
      nativity: "",
      category: "",
      religion: "",
      community: "",
      caste: "",
      houseAddress: {
        address: "",
        street: "",
        village: "",
        taluk: "",
        district: "",
        pin: "",
      },
      permanentAddress: {
        address: "",
        street: "",
        village: "",
        taluk: "",
        district: "",
        pin: "",
      },
    });
  };


  const [csrfToken, setCsrfToken] = useState("");
  const [errors, setErrors] = useState({
    parentName: "",
    gender: "",
    dob: "",
    citizenship: "",
    aadhar: "", // ADD THIS
    nativity: "",
    category: "",
    religion: "",
    community: "",
    caste: "",
    houseAddress: {
      address: "",
      street: "",
      village: "",
      taluk: "",
      district: "",
      pin: "",
    },
    permanentAddress: {
      address: "",
      street: "",
      village: "",
      taluk: "",
      district: "",
      pin: "",
    },
  });

  const validateField = (name, value) => {
    let errorMessage = "";

    if (name === "appName" && !/^[a-zA-Z][a-zA-Z\s@]{3,}$/.test(value.trim())) {
      errorMessage = "Application name must be at least 3 characters.";
    }
    if (
      name === "parentName" &&
      !/^[a-zA-Z][a-zA-Z\s@]{3,}$/.test(value.trim())
    ) {
      errorMessage = "Invalid Parent Name";
    }
    if (name === "gender" && value.trim() === "") {
      errorMessage = "Please select Gender";
    }
    if (name === "dob") {
      if (value === "") {
        errorMessage = "Please Enter Your Date of Birth";
      } else {
        const enteredDate = new Date(value);
        const today = new Date();
        const seventeenYearsAgo = new Date();
        const minDOB = new Date();
        minDOB.setFullYear(today.getFullYear() - 65);
        seventeenYearsAgo.setFullYear(today.getFullYear() - 17);

        if (enteredDate > seventeenYearsAgo || enteredDate < minDOB) {
          errorMessage = "Date of birth is invalid.";
        }
      }
    } else if (name === "dob" && new Date(value) > new Date()) {
      errorMessage = "Date of birth cannot be in the future.";
    }
    if (name === "citizenship" && value.trim() === "") {
      errorMessage = "Please select Citizenship";
    }
    if (name === "nativity" && value.trim() === "") {
      errorMessage = "Please select Nativity";
    }
    if (name === "category" && value.trim() === "") {
      errorMessage = "Please select Category";
    }
    if (name === "religion" && value.trim() === "") {
      errorMessage = "Please select Religion";
    }
    if (name === "community" && value.trim() === "") {
      errorMessage = "Please select community";
    }
    if (
      name === "caste" &&
      value.trim() === ""
    ) {
      errorMessage = "Please select caste";
    }
    if (name.includes("address") && value.trim().length < 1) {
      errorMessage = "Address cannot be empty";
    }
    if (name.includes("street") && value.trim().length < 1) {
      errorMessage = "Street cannot be empty";
    }
    if (name.includes("village") && value.trim().length < 1) {
      errorMessage = "Village cannot be empty";
    }
    if (name.includes("taluk") && value.trim().length < 1) {
      errorMessage = "Taluk cannot be empty";
    }
    if (name.includes("district") && value.trim().length < 1) {
      errorMessage = "District cannot be empty";
    }
    if (name.includes("pin") && !/^\d{6}$/.test(value)) {
      errorMessage = "PIN code must be 6 digits.";
    }
    if (name === "aadhar") {
      if (formData.citizenship === "Indian") {
        if (value.trim() === "") {
          errorMessage = "Aadhaar Number is required";
        }
      }
    }
    setErrors((prevErrors) => {
      const updatedErrors = { ...prevErrors };
      if (name.includes(".")) {
        setNestedValue(updatedErrors, name, errorMessage);
      } else {
        updatedErrors[name] = errorMessage;
      }
      return updatedErrors;
    });
    return errorMessage;
  };

  const setNestedValue = (object, path, value) => {
    const keys = path.split(".");
    let tempObj = object;
    keys.slice(0, -1).forEach((key) => {
      if (!tempObj[key]) tempObj[key] = {};
      tempObj = tempObj[key];
    });
    tempObj[keys[keys.length - 1]] = value;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => {
      const updatedFormData = { ...prev };

      if (name.includes(".")) {
        setNestedValue(updatedFormData, name, value);
      } else {

        // Reset caste whenever community changes
        if (name === "community") {
          updatedFormData["caste"] = "";
        }

        // Citizenship changed to Others
        if (name === "citizenship" && value === "Others") {
          updatedFormData["nativity"] = "Others";
          updatedFormData["community"] = "OC";
          updatedFormData["caste"] = "other";
        }

        // Citizenship changed back to Indian
        if (name === "citizenship" && value === "Indian") {
          updatedFormData["nativity"] = "";
          updatedFormData["community"] = "";
          updatedFormData["caste"] = "";
        }

        updatedFormData[name] = value;
      }
      if (name === "citizenship" && value === "Others") {
        updatedFormData["aadhar"] = "";
        updatedFormData["nativity"] = "Others";
        updatedFormData["community"] = "OC";
        updatedFormData["caste"] = "other";
      }

      return updatedFormData;
    });

    if (!(errors[name] === "" && !errors[name])) {
      validateField(name, value);
    }
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;
    validateField(name, value);
  }

  const validateForm = () => {
    let isValid = true;
    const newErrors = {};
    Object.keys(formData).forEach((key) => {
      const value = formData[key];
      if (typeof value === "object") {
        // For nested fields (e.g., address)
        Object.keys(value).forEach((nestedKey) => {
          const nestedValue = value[nestedKey];
          const error = validateField(`${key}.${nestedKey}`, nestedValue);
          if (error) {
            // console.log("error", error);
            isValid = false;
            setNestedValue(newErrors, `${key}.${nestedKey}`, error);
          }
        });
      } else {
        const error = validateField(key, value);
        if (error) {
          isValid = false;
          newErrors[key] = error;
        }
      }
    });

    setErrors(newErrors);

    return isValid;
  };

  const handlePersonalDetailSubmit = async () => {
    //if the user's nativity is tamilnadu we don't need the category
    if (formData.nativity === "TamilNadu") {
      delete formData["category"];
    }

    if (!validateForm()) {
      setModalType({
        icon: "warning",
        title: "Warning",
        text: "Please Fill All the Required Details",
      });
      openModal();
      setOnConfirm(() => closeModal);
      // console.log("Form is not valid");
      return;
    } else {
      try {
        setLoading(true);
        const response = await axios.post(
          `${serverUrl}/api/user/personalInfo`,
          { formData },
          {
            headers: {
              "CSRF-Token": csrfToken,
            },
            withCredentials: true,
          }
        );
        if (response.status === 200) {
          setModalType({
            icon: "success",
            title: "Success",
            text: "Personal Details are saved.",
          });
          openModal();
          setOnConfirm(() => handleNext);
        } else {
          // console.log(response);
        }
      } catch (err) {
        console.error("Failed to store data", err);
      }
      finally {
        setLoading(false);
      }
    }
  };

  // First useEffect: Fetch CSRF token
  useEffect(() => {
    const fetchCsrfToken = async () => {
      try {
        const response = await axios.get(`${serverUrl}/api/csrf-token`, {
          withCredentials: true, // Ensure cookies are sent
        });
        setCsrfToken(response.data.csrfToken); // Set CSRF token
      } catch (error) {
        console.error("Error fetching CSRF token:", error);
      }
    };

    fetchCsrfToken();
  }, []); // Empty dependency array: runs only on mount

  // Second useEffect: Fetch user data after CSRF token is fetched
  useEffect(() => {
    const fetchUserData = async () => {
      if (csrfToken) {
        try {
          setLoading(true);
          const userDataFromLocalStorage = auth.user;
          if (userDataFromLocalStorage) {
            const response = await axios.post(
              `${serverUrl}/api/user/loadPersonalInfo`,
              {
                appno: userDataFromLocalStorage.appno,
                userName: userDataFromLocalStorage.userName,
                email: userDataFromLocalStorage.email,
                mobile: userDataFromLocalStorage.mobile,
              },
              {
                headers: {
                  "CSRF-Token": csrfToken, // Use CSRF token
                },
                withCredentials: true,
              }
            );
            if (response.data.houseAddress === "") {
              setDefaultForm();
            } else {
              setFormData(response.data); // Set user data
            }
          }
        } catch (error) {
          console.error("Error fetching user data:", error);
        } finally {
          setLoading(false);
        }
      }
    };

    fetchUserData();
  }, [csrfToken]); // Dependency on csrfToken: runs when csrfToken changes

  // Third useEffect for the changes in the community
  useEffect(() => {
    const handleCommunityChange = () => {

      // Foreign citizens -> only OC
      if (formData.citizenship === "Others") {
        setCommunities(["OC"]);

        setFormData((prev) => ({
          ...prev,
          community: "OC",
          caste: "other",
        }));

        return;
      }

      let newCommunities = ["OC"];

      if (formData.nativity !== "Others") {
        if (formData.religion === "M") {
          newCommunities = ["BCM"];
        }
        else if (
          formData.religion === "C" ||
          formData.religion === "H"
        ) {
          newCommunities.push("BC");
          newCommunities.push("MBC");
          newCommunities.push("SC");
          newCommunities.push("SCA");
          newCommunities.push("ST");
        }
        else if (formData.nativity === "TamilNadu") {
          newCommunities.push("BC");
          newCommunities.push("BCM");
          newCommunities.push("MBC");
          newCommunities.push("SC");
          newCommunities.push("SCA");
          newCommunities.push("ST");
        }
      }

      setCommunities(newCommunities);
    };

    handleCommunityChange();

  }, [
    formData.citizenship,
    formData.nativity,
    formData.religion
  ]);

  // Handle loading state
  if (loading) {
    return <Loader />;
  }

  return (
    <section>
      <div className="section-head-container">
        <h2 className="section-title">Personal Information</h2>
        {/* <button className='log-btn button-primary' onClick={handleNext}>Save & Next</button> */}
      </div>
      <div className="form-group">
        <div>
          <div className="form-item">
            <label>Name of the Applicant</label>
            <span>(விண்ணப்பதாரரின் பெயர்)</span>
            <input
              type="text"
              name="appName"
              placeholder="Name of the Applicant"
              value={formData.appName}
              onChange={handleChange}
              disabled
            />
            {errors.name && (
              <span className="form-item-incorrect">{errors.name}</span>
            )}
          </div>
          <div className="form-item">
            <label>Email</label>
            <span>(மின்னஞ்சல் முகவரி)</span>
            <input
              type="email"
              name="email"
              placeholder="Enter Email"
              value={formData.email}
              onChange={handleChange}
              disabled
            />
          </div>
          <div className="form-item">
            <label>Contact Number</label>
            <span>(கைப்பேசி எண்)</span>
            <input
              type="text"
              name="phone"
              placeholder="Enter Contact Number"
              value={formData.phone}
              onChange={handleChange}
              disabled
            />
          </div>
          <div className="form-item">
            <label>Name of Parent/Guardian-with initital </label>
            <span>(பெற்றோர் / காப்பாளர் பெயர்)</span>
            <input
              className={errors.parentName === "" ? "valid" : "not-valid"}
              type="text"
              name="parentName"
              placeholder="Enter Name of Parent/Guardian"
              value={formData.parentName}
              onChange={handleChange}
              onBlur={handleBlur}
              required
            />
            {errors.parentName && (
              <span className="form-item-incorrect">{errors.parentName}</span>
            )}
          </div>
          <div className="form-item">
            <label>Gender</label>
            <span>(பாலினம்)</span>
            <select
              name="gender"
              value={formData.gender}
              onChange={handleChange}
              onBlur={handleBlur}
              required
            >
              <option value=""> --- Select Gender --- </option>
              <option value="Male">Male</option>
              <option value="Female">Female</option>
              <option value="Other">Other</option>
            </select>
            {errors.gender && (
              <span className="form-item-incorrect">{errors.gender}</span>
            )}
          </div>
          <div className="form-item">
            <label>Date of Birth</label>
            <span>(பிறந்த தேதி)</span>
            <input
              type="date"
              name="dob"
              value={formData.dob}
              onChange={handleChange}
              onBlur={handleBlur}
              required
            />
            {errors.dob && (
              <span className="form-item-incorrect">{errors.dob}</span>
            )}
          </div>
        </div>
        <div>
          <div className="form-item">
            <label>Citizenship</label>
            <span>(குடியுரிமை)</span>
            <select
              name="citizenship"
              value={formData.citizenship}
              onChange={handleChange}
              onBlur={handleBlur}
              required
            >
              <option value=""> --- Select Citizenship --- </option>
              <option value="Indian">Indian</option>
              <option value="Others">Others</option>
            </select>
            {errors.citizenship && (
              <span className="form-item-incorrect">{errors.citizenship}</span>
            )}
          </div>
          {formData.citizenship === "Indian" && (
            <div className="form-item">
              <label>Aadhaar Number</label>
              <span>(ஆதார் எண்)</span>
              <input
                type="text"
                name="aadhar"
                placeholder="Enter Aadhaar Number"
                value={formData.aadhar
                  .replace(/\s/g, "")
                  .replace(/(\d{4})(?=\d)/g, "$1 ")
                  .trim()}
                maxLength={14}
                onChange={(e) => {
                  const rawValue = e.target.value.replace(/\D/g, ""); // remove spaces & non-digits

                  handleChange({
                    target: {
                      name: "aadhar",
                      value: rawValue, // stored without spaces
                    },
                  });
                }}
                onBlur={handleBlur}
                required
              />

              {errors.aadhar && (
                <span className="form-item-incorrect">
                  {errors.aadhar}
                </span>
              )}
            </div>
          )}
          <div className="form-item">
            <label>Nativity</label>
            <span>(பிறப்பிடம்)</span>
            <select
              name="nativity"
              value={formData.nativity}
              onChange={handleChange}
              onBlur={handleBlur}
              required
            >
              <option value="" disabled={formData.citizenship === "Others"}> --- Select Nativity --- </option>
              {formData.citizenship === "Indian" && (
                <option value="TamilNadu">Tamil Nadu</option>
              )}
              <option value="Others">Others</option>
            </select>
            {errors.nativity && (
              <span className="form-item-incorrect">{errors.nativity}</span>
            )}
          </div>
          {formData.nativity === "Others" && (
            <div className="form-item">
              <label>Category</label>
              <span>(வகை)</span>
              <select
                name="category"
                value={formData.category}
                onChange={handleChange}
                onBlur={handleBlur}
                required
              >
                <option value=""> --- Select Category --- </option>
                <option value="1">
                  Continuously Studied for past five years in Tamilnadu
                </option>
                <option value="2">
                  My parent is Central Government/ State Government/Public
                  sector Employee for past five years continuously in Tamilnadu
                </option>
                <option value="3">
                  My parent is serving as All India Tamilnadu Cadre officer
                </option>
              </select>
              {errors.category && (
                <span className="form-item-incorrect">{errors.category}</span>
              )}
            </div>
          )}
          <div className="form-item">
            <label>Religion</label>
            <span>(மதம்)</span>
            <select
              name="religion"
              value={formData.religion}
              onChange={handleChange}
              onBlur={handleBlur}
              required
            >
              <option value=""> --- Select Religion --- </option>
              <option value="H">Hindu</option>
              <option value="M">Muslim</option>
              <option value="C">Christian</option>
              {/* <option value="O">Others</option> */}
            </select>
            {errors.religion && (
              <span className="form-item-incorrect">{errors.religion}</span>
            )}
          </div>
          <div className="form-item">
            <label>Community</label>
            <span>(சாதி)</span>

            <select
              name="community"
              value={formData.community}
              onChange={handleChange}
              onBlur={handleBlur}
              required
            >
              <option value="" disabled={formData.citizenship === "Others"}> --- Select Community --- </option>
              {communities.map((item) => (
                <option value={item}>{item}</option>
              ))}
            </select>
            {errors.community && (
              <span className="form-item-incorrect">{errors.community}</span>
            )}
          </div>
          <div className="form-item">
            <label>Caste</label>
            <span>(சாதிப்பெயர்)</span>
            <select
              name="caste"
              value={formData.caste}
              onChange={handleChange}
              onBlur={handleBlur}
              required
            >
              <option value="" disabled={formData.citizenship === "Others"}> --- Select Caste --- </option>

              {formData.community === "BC" &&
                BC.map((item) => (
                  <option key={item.code} value={item.code}>
                    {item.code} - {item.name}
                  </option>
                ))}
              {formData.community === "MBC" &&
                MBC.map((item) => (
                  <option key={item.code} value={item.code}>
                    {item.code} - {item.name}
                  </option>
                ))}
              {formData.community === "BCM" &&
                BCM.map((item) => (
                  <option key={item.code} value={item.code}>
                    {item.code} - {item.name}
                  </option>
                ))}
              {formData.community === "SC" &&
                SC.map((item) => (
                  <option key={item.code} value={item.code}>
                    {item.code} - {item.name}
                  </option>
                ))}
              {formData.community === "SCA" &&
                SCA.map((item) => (
                  <option key={item.code} value={item.code}>
                    {item.code} - {item.name}
                  </option>
                ))}
              {formData.community === "ST" &&
                ST.map((item) => (
                  <option key={item.code} value={item.code}>
                    {item.code} - {item.name}
                  </option>
                ))}
              {formData.community === "OC" && <option value="other">Other</option>}
            </select>
            {errors.caste && (
              <span className="form-item-incorrect">{errors.caste}</span>
            )}
          </div>
        </div>
      </div>
      <br />
      <div className="next-button">
        <input
          type="submit"
          className="button button-primary"
          onClick={handlePersonalDetailSubmit}
          value="Save & Next"
        />
      </div>
      <div
        style={{
          position: "relative",
          alignSelf: "center",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <PopModal
          isOpen={isModalOpen}
          type={modalType}
          confirmButtonText="OK"
          onConfirm={onConfirm}
        />
      </div>
    </section>
  );
}

export default PersonalDetails;
